<nz-layout>
    <nz-header class="flex items-center justify-between px-4">
        <div class="flex items-center gap-2">
            <button
                nz-button
                nzType="link"
                (click)="closeDrawer()"
                aria-label="Close Subscription Details Drawer"
            >
                <i class="fa-solid fa-x"></i>
            </button>
            <span
                *ngIf="subscription?.customer?._id"
                class="text-base font-bold"
            >
                Customer:
                {{
                    (subscription?.customer?.firstName || '') +
                        ' ' +
                        (subscription?.customer?.lastName || '') | titlecase
                }}
            </span>
        </div>
        <nz-select
            class="min-w-[200px]"
            nzPlaceHolder="Select a coupon"
            nzAllowClear
            nzShowSearch
            [(ngModel)]="selectedCouponCode"
            (ngModelChange)="onCouponChange($event)"
        >
            <nz-option
                *ngFor="let coupon of coupons"
                [nzValue]="coupon.code"
                [nzLabel]="coupon.code"
            ></nz-option>
        </nz-select>
    </nz-header>

    <nz-content class="p-4">
        <section class="bg-gray-20 p-4 rounded-md shadow my-2">
            <p>
                <b>Status:</b> {{ subscriptionStatuses[subscription?.status] }}
            </p>
            <p><b>Current Cycle:</b> {{ subscription?.currentCycle }}</p>
            <p>
                <b>Next Cycle Date:</b> {{ subscription?.nextCycleDate | date }}
            </p>
        </section>

        <section class="p-4 bg-gray-50 rounded-lg my-4 border border-gray-200">
            <h3>Phases</h3>
            <form [formGroup]="FG" (ngSubmit)="submit()" class="space-y-4">
                <div
                    formArrayName="subscriptionPhases"
                    class="flex flex-col gap-y-2"
                >
                    <div
                        *ngFor="
                            let phase of subscriptionPhases.controls;
                            index as i
                        "
                        class="border-b border-gray-300 p-3"
                    >
                        <ng-container [formGroupName]="i">
                            <nz-row
                                nzJustify="between"
                                nzAlign="middle"
                                class="items-center"
                            >
                                <p
                                    nz-col
                                    nzFlex="auto"
                                    style="font-weight: bold; margin: 0"
                                    class="text-md"
                                >
                                    Phase {{ i + 1 }}
                                </p>
                                <nz-tag
                                    *ngIf="i === activePhaseIndex"
                                    nzColor="green"
                                    class="ml-2"
                                >
                                    Active Phase
                                </nz-tag>
                            </nz-row>

                            <nz-row [nzGutter]="12">
                                <!-- left column -->
                                <nz-col [nzSm]="24" [nzMd]="6">
                                    <nz-form-item>
                                        <nz-form-label nzFor="price"
                                            >Sale Price</nz-form-label
                                        >
                                        <nz-form-control>
                                            <nz-input-number-group
                                                nzAddOnBefore="$"
                                            >
                                                <nz-input-number
                                                    placeholder="Phase Price"
                                                    formControlName="price"
                                                    style="min-width: 60px"
                                                >
                                                </nz-input-number>
                                            </nz-input-number-group>
                                        </nz-form-control>
                                    </nz-form-item>

                                    <nz-form-item>
                                        <nz-form-label
                                            >No. of Cycles</nz-form-label
                                        >
                                        <nz-form-control
                                            style="width: 80px"
                                            nzExtra="(0 for never ending)"
                                        >
                                            <nz-input-number
                                                [nzMin]="0"
                                                placeholder="Cycles Count"
                                                formControlName="cycles"
                                                style="width: 80px"
                                            />
                                        </nz-form-control>
                                    </nz-form-item>
                                </nz-col>

                                <!-- right column -->
                                <nz-col
                                    [nzSm]="{ offset: 0, span: 24 }"
                                    [nzMd]="{ offset: 2, span: 16 }"
                                    [nzLg]="{ offset: 6, span: 12 }"
                                >
                                    <nz-form-item>
                                        <nz-form-label
                                            nzFor="fillingCycleInterval"
                                            >Cycle Duration</nz-form-label
                                        >
                                        <nz-form-control nzMd="10" nzSm="24">
                                            <nz-input-group nzCompact>
                                                <input
                                                    type="text"
                                                    nz-input
                                                    placeholder="Cycle Duration"
                                                    formControlName="fillingCycleInterval"
                                                    style="
                                                        width: 30%;
                                                        padding-bottom: 5px;
                                                    "
                                                />
                                                <nz-select
                                                    placeholder="please select the product interval unit"
                                                    formControlName="fillingCycleUnit"
                                                    style="width: 70%"
                                                >
                                                    <nz-option
                                                        nzValue="day"
                                                        nzLabel="Day"
                                                    ></nz-option>
                                                    <nz-option
                                                        nzValue="week"
                                                        nzLabel="Week"
                                                    ></nz-option>
                                                    <nz-option
                                                        nzValue="month"
                                                        nzLabel="Month"
                                                    ></nz-option>
                                                    <nz-option
                                                        nzValue="year"
                                                        nzLabel="Year"
                                                    ></nz-option>
                                                </nz-select>
                                            </nz-input-group>
                                        </nz-form-control>
                                    </nz-form-item>

                                    <nz-form-item>
                                        <nz-form-control>
                                            <nz-input-number-group
                                                nzAddOnBefore="Bill every"
                                                [nzAddOnAfter]="billCycleUnit"
                                                nzCompact
                                            >
                                                <nz-input-number
                                                    style="width: 60px"
                                                    type="text"
                                                    placeholder="Billing Every Cycle"
                                                    formControlName="billableCycleInterval"
                                                />
                                                <ng-template #billCycleUnit>
                                                    <span nz-col
                                                        >cycle<span
                                                            *ngIf="
                                                                FG.get(
                                                                    'subscriptionPhases.' +
                                                                        i
                                                                )?.value
                                                                    ?.billableCycleInterval >
                                                                1
                                                            "
                                                            >s</span
                                                        >
                                                        of this phase</span
                                                    >
                                                </ng-template>
                                            </nz-input-number-group>
                                        </nz-form-control>
                                    </nz-form-item>

                                    <nz-form-item>
                                        <nz-form-control>
                                            <nz-input-number-group
                                                nzAddOnBefore="Fulfillment every"
                                                nzAddOnAfter="cycle of this phase"
                                                nzCompact
                                            >
                                                <nz-input-number
                                                    style="width: 70px"
                                                    placeholder="1"
                                                    formControlName="fulfillmentCycleInterval"
                                                    nzMin="1"
                                                />
                                            </nz-input-number-group>
                                        </nz-form-control>
                                    </nz-form-item>

                                    <nz-form-item>
                                        <nz-form-control>
                                            <nz-input-number-group
                                                nzAddOnBefore="Requirement every"
                                                nzAddOnAfter="cycle of this phase"
                                                nzCompact
                                            >
                                                <nz-input-number
                                                    style="width: 70px"
                                                    placeholder="—"
                                                    formControlName="requirementCycleInterval"
                                                    nzMin="1"
                                                />
                                            </nz-input-number-group>
                                        </nz-form-control>
                                    </nz-form-item>
                                </nz-col>
                            </nz-row>

                            <div
                                style="
                                    padding-bottom: 20px;
                                    color: orangered;
                                    font-weight: bold;
                                "
                            >
                                <ng-container
                                    *ngIf="
                    FG.get('subscriptionPhases.' + i)?.errors?.['billableCycleInterval'] && 
                    (FG.get('subscriptionPhases.' + i)?.touched || FG.get('subscriptionPhases.' + i)?.dirty)
                    "
                                >
                                    {{
                                        FG.get('subscriptionPhases.' + i)
                                            ?.errors?.billableCycleInterval
                                    }}
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        FG.get('subscriptionPhases.' + i)?.errors?.['fulfillmentCycleInterval'] && 
                                        (FG.get('subscriptionPhases.' + i)?.touched || FG.get('subscriptionPhases.' + i)?.dirty)
                                    "
                                >
                                    {{
                                        FG.get('subscriptionPhases.' + i)
                                            ?.errors?.fulfillmentCycleInterval
                                    }}
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        FG.get('subscriptionPhases.' + i)?.errors?.['requirementCycleInterval'] && 
                                        (FG.get('subscriptionPhases.' + i)?.touched || FG.get('subscriptionPhases.' + i)?.dirty)
                                    "
                                >
                                    {{
                                        FG.get('subscriptionPhases.' + i)
                                            ?.errors?.requirementCycleInterval
                                    }}
                                </ng-container>
                                <ng-container
                                    *ngIf="
                                        phase.get('cycles').value === 0 &&
                                        (FG.get('subscriptionPhases')?.errors
                                            ?.multipleZeroCycles ||
                                            FG.get('subscriptionPhases')?.errors
                                                ?.zeroCycleNotLast)
                                    "
                                    style="color: #ff4d4f; margin-top: 8px"
                                >
                                    <ng-container
                                        *ngIf="
                                            FG.get('subscriptionPhases')?.errors
                                                ?.multipleZeroCycles
                                        "
                                    >
                                        {{
                                            FG.get('subscriptionPhases')?.errors
                                                ?.multipleZeroCycles
                                        }}
                                    </ng-container>
                                    <ng-container
                                        *ngIf="
                                            FG.get('subscriptionPhases')?.errors
                                                ?.zeroCycleNotLast
                                        "
                                    >
                                        {{
                                            FG.get('subscriptionPhases')?.errors
                                                ?.zeroCycleNotLast
                                        }}
                                    </ng-container>
                                </ng-container>
                            </div>
                            <nz-row>
                                <nz-form-item nz-col nzSpan="24">
                                    <nz-form-label>Requirements</nz-form-label>
                                    <nz-form-control>
                                        <nz-select
                                            placeholder="please select the product requirements"
                                            formControlName="requirements"
                                            nzMode="tags"
                                        >
                                            <nz-option
                                                *ngFor="let q of requirements"
                                                [nzValue]="q.value"
                                                [nzLabel]="q.label"
                                            ></nz-option>
                                        </nz-select>
                                    </nz-form-control>
                                </nz-form-item>
                            </nz-row>
                        </ng-container>
                    </div>
                </div>

                <!-- Submit Button -->
                <div class="flex justify-end pt-4 border-gray-200">
                    <button
                        nz-button
                        nzType="primary"
                        type="submit"
                        [nzLoading]="loading$ | async"
                        [disabled]="FG.invalid || (loading$ | async)"
                    >
                        Save
                    </button>
                </div>
            </form>
        </section>

        <section
            class="bg-gray-20 p-4 rounded-md shadow my-4"
            *ngIf="subscription?.customer"
        >
            <portals-emr-notes-list
                [subscription]="subscription"
                label="Notes"
            ></portals-emr-notes-list>
        </section>

        <section
            class="bg-gray-20 p-4 rounded-md shadow text-sm my-4"
            *ngIf="subscription?._id"
        >
            <div class="flex flex-row flex-wrap">
                <div class="px-3 py-1 bg-white rounded-md m-1">
                    <span class="font-bold">_id: </span>
                    <span>{{ subscription?._id }}</span>
                </div>
                <div class="px-3 py-1 bg-white rounded-md m-1">
                    <span class="font-bold">created: </span>
                    <span>{{ subscription?.createdAt | date : 'medium' }}</span>
                </div>
            </div>
        </section>

        <section
            class="bg-gray-20 p-4 rounded-md shadow my-4"
            *ngIf="subscription?.statusHistory?.length"
        >
            <nz-divider
                nzText="Subscription History"
                nzOrientation="left"
            ></nz-divider>
            <nz-timeline nzMode="left">
                <nz-timeline-item
                    [nzLabel]="
                        subscription.createdAt | date : 'MMM d, y, h:mm a'
                    "
                >
                    <nz-tag>
                        {{
                            subscriptionStatuses[
                                subscription.statusHistory[0].prevStatus
                            ]
                        }}
                    </nz-tag>
                </nz-timeline-item>

                <nz-timeline-item
                    *ngFor="let history of subscription.statusHistory"
                    [nzLabel]="history.updatedAt | date : 'MMM d, y, h:mm a'"
                >
                    <nz-tag>{{
                        subscriptionStatuses[history.newStatus]
                    }}</nz-tag>

                    <nz-tag *ngIf="history?.fullName; else userBlock">
                        {{ history?.fullName }}
                    </nz-tag>

                    <ng-template #userBlock>
                        <ng-container
                            *ngTemplateOutlet="
                                userName;
                                context: {
                                    $implicit:
                                        history.userId | userDetails | async
                                }
                            "
                        ></ng-container>
                    </ng-template>
                </nz-timeline-item>
            </nz-timeline>
        </section>

        <section
            class="bg-gray-20 p-4 rounded-md shadow my-4"
            *ngIf="subscription?.renewalHistory?.length"
        >
            <nz-divider
                nzText="Renewal History"
                nzOrientation="left"
            ></nz-divider>
            <nz-timeline nzMode="left">
                <nz-timeline-item
                    *ngFor="let renewal of subscription.renewalHistory"
                    [nzLabel]="getActionLabel(renewal)"
                >
                    <div class="flex flex-col gap-2">
                        <div class="flex items-center gap-2">
                            <nz-tag> Cycle {{ renewal.cycleNumber }} </nz-tag>

                            <ng-container
                                *ngTemplateOutlet="
                                    userName;
                                    context: {
                                        $implicit:
                                            renewal.userId | userDetails | async
                                    }
                                "
                            ></ng-container>
                        </div>

                        <!-- Additional details for renewal date changes -->
                        <div
                            *ngIf="
                                renewal.type === 'update_renewal_date' &&
                                renewal.previousRenewalDate &&
                                renewal.newRenewalDate
                            "
                            class="text-sm text-gray-600 bg-gray-50 p-2 rounded"
                        >
                            Changed from
                            {{
                                renewal.previousRenewalDate | date : 'M/d/yyyy'
                            }}
                            to {{ renewal.newRenewalDate | date : 'M/d/yyyy' }}
                        </div>
                    </div>
                </nz-timeline-item>
            </nz-timeline>
        </section>
    </nz-content>
</nz-layout>

<ng-template #userName let-user>
    <nz-tag>{{ user?.firstName }} {{ user?.lastName }}</nz-tag>
</ng-template>
